<script setup lang="ts">
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';

const contentStore = useContentStore();
const { searchResultContent, searchResultContentsLoading } =
    classToRefs(contentStore);
const expanded = ref(false);
</script>
<template>
    <div
        v-show="!searchResultContentsLoading && searchResultContent"
        class="article-root container"
        :class="{ collapsed: !expanded }"
    >
        <article v-html="searchResultContent" />
        <mr-button
            v-if="!expanded"
            variant="transparent"
            size="medium"
            class="expand"
            :left-icon="faAngleDown"
            @click="expanded = true"
        >
            مطالعه بیشتر
        </mr-button>
    </div>
</template>

<style lang="scss" scoped>
.article-root {
    padding-top: 28px;
    @include mobile-only {
        padding-inline: 8px;
        padding-bottom: 28px;
    }
    .expand {
        display: none;
        @include mobile-only {
            display: flex;
        }
    }
    &.collapsed {
        :deep() {
            p:first-of-type {
                @include mobile-only {
                    overflow: hidden;
                    line-clamp: 10;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 10;
                    display: -webkit-box;
                    & ~ * {
                        display: none;
                    }
                }
            }
        }
    }
    strong {
        @include font-weight(bold);
    }
    :deep() {
        h1 {
            display: flex;
            align-items: center;
            @include tg-display4($w7);
            margin-bottom: 9px;
            &:before {
                content: ' ';
                display: block;
                width: 4px;
                height: 32px;
                background-color: usePalette($p-blue, $p-300);
                margin-left: 8px;
                border-radius: 4px;
            }
        }
        h2 {
            @include tg-xl($w7, usePalette($p-gray, $p-800));
            margin-top: 0;
            margin-bottom: 9px;
        }
        h3 {
            @include tg-l($w7, usePalette($p-gray, $p-800));
            margin-top: 0;
            margin-bottom: 9px;
        }
        p {
            @include tg-m($w5, usePalette($p-gray, $p-800));
            margin-top: 0;
            margin-bottom: 9px;
        }

        li {
            display: list-item;
        }

        ol {
            display: block;
            list-style: decimal;
            margin: 1em 0;
            padding-right: 40px;
        }

        ul {
            display: block;
            list-style: disc;
            margin: 1em 0;
            padding-right: 40px;
        }
    }
}
</style>
